import { useContext } from 'react';
import images, { ExistingImages } from '../../assets/images';
import { BackgroundContext } from '../../components/templates/Layout/Layout';

export const useSetBackground = (imageName: ExistingImages) => {
  const { setBackground } = useContext(BackgroundContext);
  setBackground(imageName === null ? null : images[imageName]);
};
